import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Pagination, Employee } from "@/v2/types";

export default async function FindAllEmployees({
    limit,
    skip,
    search,
    filter,
}: {
    skip?: number;
    limit?: number;
    search?: string;
    filter?: Record<string, Record<string, any>>;
}): Promise<{ data: Employee[]; pagination: Pagination }> {
    const res = await apiClientWithRefreshToken({
        url: "/employees",
        method: "GET",
        params: {
            skip: skip ?? 0,
            limit: limit ?? 10,
            ...(search && { search }),
            ...(filter && { ...filter }),
        },
    });

    return res.data;
}
